import { MEDIA_BASE_URL } from "../../settings";

/**
 * NSW Design System hero banner, "with supporting image" variant.
 * https://designsystem.nsw.gov.au/components/hero-banner/index.html
 *
 * No call-to-action button: the "Message" control already lives in the map
 * header, and a second competing CTA here would split the one action this
 * page asks for.
 */
const NswHeroBanner = () => (
  <div className="nsw-hero-banner nsw-hero-banner--dark" id="nsw-hero-banner">
    <div className="nsw-hero-banner__container">
      <div className="nsw-hero-banner__wrapper">
        <div className="nsw-hero-banner__content">
          <h1>NSW Teaching Gems Map</h1>
          <p className="nsw-intro">
            Celebrate your teachers this World Teachers’ Day in NSW by adding a
            gem to our Teaching Gems Map!
          </p>
        </div>
        <div className="nsw-hero-banner__box">
          <img
            className="nsw-hero-banner__image"
            src={encodeURI(MEDIA_BASE_URL + "/img/Hero banner supporting image.png")}
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
);

export default NswHeroBanner;
